import { useEffect, useState } from "react";

import useAppSelector from "hooks/store/useAppSelector";
import useGlobalVariables from "hooks/useGlobalVariables";
import SessionStorageUtils from "utils/sessionStorage";

import {
	selectPlayerCurrencyCode,
	selectSessionId,
	selectSessionPromotions,
} from "store/slices/auth/selectors";

import PromotionModalNotificationView from "../promotionModalNotification-view";
import getStoragePromotionDefaultData from "../helpers/getStoragePromotionDefaultData";
import PromotionModalView from "components/promotionModalNotification/promotionsModal-view/index.jsx";
import useAppDispatch from "hooks/store/useAppDispatch.js";
import { getPromotionBets, selectShowPromotionRules } from "store/slices/promotion/selectors.js";
import { setPromotionBets, setShowPromotionRulesAction, setUsePromotionAction } from "store/slices/promotion/actions.js";
import BecamePromotionModal from "components/promotionModalNotification/becamePromotionModal/index.jsx";
import { setModalReadyToShowAction } from "store/slices/bonus/actions.js";

const PromotionModalNotificationContainer = () => {
	const [isVisible, setIsVisible] = useState(false);
	const { isMobile, isTablet } = useGlobalVariables();
	const sessionId = useAppSelector(selectSessionId);
	const promotions = useAppSelector(selectSessionPromotions);
	const currencyCode = useAppSelector(selectPlayerCurrencyCode);
	const showPromotionRules = useAppSelector(selectShowPromotionRules);
	const promotionBets = useAppSelector(getPromotionBets);
	const [visibleBecamePromotionModal, setVisibleBecamePromotionModal] = useState(false);

	const dispatch = useAppDispatch();

	useEffect(() => {
		if(promotionBets.data.length) {
			setVisibleBecamePromotionModal(true)
		} else {
			setVisibleBecamePromotionModal(false)
		}
	}, [promotionBets.data.length]);


	useEffect(() => {
		if (!sessionId || !promotions.doubleDooble) {
			setIsVisible(false);
			return;
		}

		const storagePromotionData = SessionStorageUtils.get(`promotion${sessionId}`);
		if (Boolean(storagePromotionData) && storagePromotionData.modalNotificationHasAlreadyShown) {
			setIsVisible(false);
			return;
		}
		const defaultData = getStoragePromotionDefaultData();
		defaultData.modalNotificationHasAlreadyShown = true;
		SessionStorageUtils.set(`promotion${sessionId}`, defaultData);
		setIsVisible(true);
	}, [sessionId]);

	useEffect(() => {
		if (!promotions.doubleDooble) {
			dispatch(setModalReadyToShowAction(true));
		}
	}, [promotions.doubleDooble]);

	const handleOnOk = () => {
		setIsVisible(false);
		dispatch(setShowPromotionRulesAction(false));
		dispatch(setUsePromotionAction(true));
	};

	const handleOnActivatePromotions = () => {
		setIsVisible(false);
		dispatch(setShowPromotionRulesAction(false));
		dispatch(setUsePromotionAction(true));
	};

	const moreButtonHandler = () => {
		setIsVisible(false);
		dispatch(setShowPromotionRulesAction(true));
	};

	const closeBecomePromotionModal = () => {
		dispatch(setPromotionBets([]));
	}

	return (
		<>
			<BecamePromotionModal
				isVisible={visibleBecamePromotionModal}
				promotionBets={promotionBets.data}
				isMulti={promotionBets.isMulti}
				totalFactor={promotionBets.totalFactor}
				possibleWin={promotionBets.possibleWin}
				handleOnOk={closeBecomePromotionModal}
				isMobile={isMobile}
			/>

			<PromotionModalNotificationView
				isVisible={isVisible}
				promotions={promotions.doubleDooble}
				currencyCode={currencyCode}
				isMobile={isMobile}
				isTablet={isTablet}
				handleOnOk={handleOnOk}
				handleOnActivatePromotions={handleOnActivatePromotions}
				moreButtonHandler={moreButtonHandler}
			/>

			<PromotionModalView
				isVisible={showPromotionRules}
				promotions={promotions.doubleDooble}
				currencyCode={currencyCode}
				isMobile={isMobile}
				isTablet={isTablet}
				handleOnOk={handleOnOk}
				handleOnActivatePromotions={handleOnActivatePromotions}
				moreButtonHandler={moreButtonHandler}
			/>
		</>
	);
};
export default PromotionModalNotificationContainer;
